export const compareAnswers = (type, arr1, arr2) => {
  let correct = 0
  let wrong = 0

  if(type === 'single' || type === 'multiple')
    arr2.map(item => arr1.find(itm => itm === item) ? correct++ : wrong++)

  // if(type === 'dragdrop' || type === 'component')
  //   arr2.map(item => arr1.find(itm => itm.aId === item.aId && checkLocation(itm.location, item.location)) ? correct++ : wrong++)

  return { correct, wrong, target: arr1.length }
}

export const checkLocation = (realLocation, pickedLocation) => {
  return Array.isArray(realLocation)
    ? realLocation.indexOf(pickedLocation) !== -1
    : realLocation === pickedLocation
}

export const getCorrectAnswers = (answers, answersAll) => {
  return answers.reduce((acc, item) => {
    const ans = answersAll[item]

    return ans.correct ? acc.concat(ans.id) : acc
  }, [])
}

export const getPoints = (type, status, total) => {
  switch(type) {
    case 'single':
    case 'multiple':
      return status.correct - status.wrong === status.target ? total : 0

    // case 'dragdrop':
    // case 'component':
    //   return status.correct * (total / status.target)

    default:
      return 0
  }
}
